import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Search } from "../search/search";

@Component({
  selector: 'app-custom-dropdown',
  imports: [TranslatePipe, CommonModule, Search],
  templateUrl: './custom-dropdown.html',
  styleUrl: './custom-dropdown.css'
})
export class CustomDropdown {
  @Input() label = '';
  @Input() placeholder = '';
  @Input() isSearchable? = false;
  @Input() searchPlaceholder? = 'Enter Text'
  @Input() options: any = [];
  @Input() customClass? = '';
  @Output() optionSelected = new EventEmitter<string>();
  selectedOption: any | null = null;
  isOpen = false;
  openUpwards = false;

  constructor(private elementRef: ElementRef) { }

  toggleDropdown() {
    if (!this.isOpen) {
      // Before opening → decide direction
      this.checkDropdownPosition();
    }
    this.isOpen = !this.isOpen;
  }

  selectOption(option: any, event: MouseEvent) {
    event.stopPropagation();
    this.selectedOption = option;
    this.optionSelected.emit(this.selectedOption);
    this.isOpen = false;
  }

  onSearchChange(value: string) {
    const search = value.toLowerCase().trim();

    //implement searching here
  }

  get filteredOptions() {
    return this.options;
  }

  //   Position logic – called before opening
  private checkDropdownPosition() {
    const triggerRect = this.elementRef.nativeElement.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    let estimatedHeight = 384; // height of dropdown list

    const spaceBelow = windowHeight - triggerRect.bottom;
    const spaceAbove = triggerRect.top;

    // If space below is not enough → open upward
    this.openUpwards = spaceBelow < estimatedHeight && spaceAbove > spaceBelow;
  }

  // Keep resize support (useful when orientation changes, window resized)
  @HostListener('window:resize')
  onResize() {
    if (this.isOpen) {
      this.checkDropdownPosition();
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target as Node)) {
      this.isOpen = false;
    }
  }

  private readonly _labelId =
    `label-${Math.random().toString(36).slice(2, 9)}`;

  get labelId() { return this._labelId; }
}
